import { Component, OnDestroy, OnInit } from '@angular/core'
import { ContentService } from '../../services/content/content.service'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { JsonLdService } from '../../services/json-ld/json-ld.service'
import { DIFFERENTIAL_SCHEMA } from '../../schemas/differential.schema'

@Component({
	selector: 'app-differential',
	templateUrl: './differential.component.html',
	styleUrls: ['./differential.component.scss'],
})
export class DifferentialComponent implements OnInit, OnDestroy {
	constructor(
		private content: ContentService,
		private title: Title,
		private meta: Meta,
		private route: ActivatedRoute,
		private jsonLd: JsonLdService
	) {}

	ngOnDestroy(): void {
		this.jsonLd.removeSchema()
	}

	ngOnInit(): void {
		const lang = this.route.snapshot.params.lang
		this.getDifferencial(lang)
		// Schema fornecido é específico da página base /diferencial (sem sub-slug)
		if (!this.route.snapshot.paramMap.get('differential')) {
			this.jsonLd.insertSchema(DIFFERENTIAL_SCHEMA)
		}
	}
	dataDifferencial: any
	differential: string | null

	getDifferencial(lang: string) {
		this.differential = this.route.snapshot.paramMap.get('differential')
		const self = this
		this.content.getPage('pages/?type=cms.Differentials&fields=*&', lang, {
			fnSuccess(data) {
				self.title.setTitle(
					data.items[0].meta.seo_title || 'Diferenciais'
				)
				self.meta.addTag({
					name: 'description',
					content: data.items[0].meta.search_description,
				})
				self.meta.updateTag(
					{
						property: 'og:description',
						content: data.items[0].meta.search_description,
					},
					"property='og:description'"
				)
				self.meta.updateTag(
					{
						property: 'og:title',
						content: data.items[0].meta.seo_title,
					},
					"property='og:title'"
				)
				self.dataDifferencial = data.items[0]
			},
			fnError(err) {
				console.warn(err)
			},
		})
	}
}
